import React, { Component } from "react";
import { Modal } from "antd";
import {
  InfoCircleFilled,
  ClockCircleFilled,
  ExclamationCircleFilled,
  WarningFilled,
  FireFilled,
  CreditCardOutlined,
  BankOutlined,
  ShopOutlined,
  LockOutlined,
} from "@ant-design/icons";
import ButtonItem from "../../../Components/ButtonItem";

class ModalAdvertenciaPago extends Component {
  getContenidoPorDias(dias) {
    const configuraciones = {
      5: { color: "#00BFD6", icono: <InfoCircleFilled />, botonColor: "cyan", nivel: "info", urgencia: "baja" },
      4: { color: "#00BFD6", icono: <ClockCircleFilled />, botonColor: "cyan", nivel: "warning", urgencia: "media-baja" },
      3: { color: "#C9DF00", icono: <ExclamationCircleFilled />, botonColor: "lima", nivel: "warning", urgencia: "media" },
      2: { color: "#FF6A0D", icono: <WarningFilled />, botonColor: "naranja2", nivel: "alert", urgencia: "media-alta" },
      1: { color: "#FF6A0D", icono: <FireFilled />, botonColor: "naranja2", nivel: "critical", urgencia: "alta" },
    };

    // Validar y ajustar el valor de dias
    let diasValido = dias;
    if (dias < 1) {
      diasValido = 1; // Si es menor a 1, usar configuración de día 1 (más crítico)
    } else if (dias > 5) {
      diasValido = 5; // Si es mayor a 5, usar configuración de día 5 (menos crítico)
    }

    const config = configuraciones[diasValido];

    const contenidos = {
      5: {
        titulo: "Aviso de Vencimiento",
        subtitulo: "Su servicio ERP BIWO ha vencido",
        mensaje: "Le informamos que su suscripción ha vencido. Para mantener el acceso completo a todas las funciones, le invitamos a realizar su pago a la brevedad.",
        cta: "Mantenga su servicio activo realizando el pago hoy mismo."
      },
      4: {
        titulo: "Recordatorio de Pago",
        subtitulo: "Pago pendiente - ERP BIWO",
        mensaje: "Aún no hemos registrado el pago correspondiente a su servicio. Le recomendamos realizarlo hoy para evitar posibles inconvenientes en su operación.",
        cta: "Realice su pago ahora para continuar operando sin interrupciones."
      },
      3: {
        titulo: "Notificación Importante",
        subtitulo: "Servicio activo por cortesía",
        mensaje: "Su servicio continúa activo temporalmente por cortesía, pero el pago sigue pendiente. Para evitar interrupciones, le invitamos a regularizar su situación cuanto antes.",
        cta: "Regularice su situación para garantizar la continuidad del servicio."
      },
      2: {
        titulo: "Aviso de Suspensión Próxima",
        subtitulo: "Acción requerida - Pago pendiente",
        mensaje: "Detectamos que aún no ha realizado el pago de su servicio. Para evitar la suspensión de su cuenta, es necesario efectuar el pago correspondiente.",
        cta: "Evite la suspensión de su servicio realizando el pago inmediatamente."
      },
      1: {
        titulo: "Último Aviso",
        subtitulo: "Suspensión inminente - ERP BIWO",
        mensaje: "Su cuenta permanece vencida. Esta es la última notificación antes de que el servicio sea suspendido.",
        cta: "¡Último día! Realice su pago para continuar operando sin interrupciones."
      }
    };

    const contenido = contenidos[diasValido];

    return {
      color: config.color,
      icono: config.icono,
      botonColor: config.botonColor,
      nivel: config.nivel,
      urgencia: config.urgencia,
      ...contenido,
      formasPago: [
        { icono: <CreditCardOutlined />, texto: "Tarjeta de crédito o débito" },
        { icono: <BankOutlined />, texto: "Transferencia bancaria" },
        { icono: <ShopOutlined />, texto: "Pago en efectivo en tiendas de conveniencia" }
      ]
    };
  }

  render() {
    const { diasFaltantes, visible, cerrarModal } = this.props;
    const contenido = this.getContenidoPorDias(diasFaltantes);
    const acento = contenido.color;
    // Colores de marca para los ítems del modal (uno por cada forma de pago)
    const coloresItems = ["#FF6A0D", "#00BFD6", "#C9DF00"];

    return (
      <Modal
        visible={visible}
        onCancel={cerrarModal}
        footer={null}
        centered
        width={470}
        closable={true}
        bodyStyle={{
          padding: "32px 30px 28px",
          borderRadius: 16,
        }}
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(3px)" }}
      >
        {/* Encabezado */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <span
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: acento,
              color: "#fff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 30,
              marginBottom: 16,
              boxShadow: `0 8px 20px ${acento}55`,
            }}
          >
            {contenido.icono}
          </span>
          <h2
            style={{
              margin: 0,
              fontSize: 22,
              fontWeight: 800,
              color: "#1c1c1e",
              letterSpacing: "-0.4px",
              lineHeight: 1.25,
            }}
          >
            {contenido.titulo}
          </h2>
          <p style={{ margin: "6px 0 0", fontSize: 14, fontWeight: 500, color: "#8c8c8c" }}>
            {contenido.subtitulo}
          </p>
        </div>

        {/* Mensaje */}
        <p style={{ fontSize: 15, lineHeight: 1.7, color: "#4a4a4a", margin: "0 0 20px", textAlign: "center" }}>
          {contenido.mensaje}
        </p>

        {/* Llamado a la acción */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            background: `${acento}12`,
            border: `1px solid ${acento}55`,
            borderLeft: `5px solid ${acento}`,
            borderRadius: 10,
            padding: "14px 18px",
            marginBottom: 26,
          }}
        >
          <span style={{ color: acento, fontSize: 20, display: "inline-flex", flexShrink: 0 }}>
            {contenido.icono}
          </span>
          <span style={{ color: acento, fontSize: 14.5, fontWeight: 700, lineHeight: 1.45 }}>
            {contenido.cta}
          </span>
        </div>

        {/* Formas de pago */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 14,
            fontWeight: 700,
            color: "#1c1c1e",
            letterSpacing: "-0.2px",
            marginBottom: 14,
          }}
        >
          Formas de pago disponibles
          <span style={{ flex: 1, height: 1, background: "#eaeaea" }} />
        </div>

        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {contenido.formasPago.map((forma, index) => {
            const colorItem = coloresItems[index % coloresItems.length];
            return (
              <li
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "12px 0",
                  fontSize: 14,
                  color: "#444",
                  borderBottom:
                    index === contenido.formasPago.length - 1 ? "none" : "1px solid #f0f0f0",
                }}
              >
                <span
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    background: colorItem,
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 17,
                    flexShrink: 0,
                    boxShadow: `0 3px 8px ${colorItem}55`,
                  }}
                >
                  {forma.icono}
                </span>
                {forma.texto}
              </li>
            );
          })}
        </ul>

        {/* Nota de seguridad */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            marginTop: 18,
            paddingTop: 16,
            borderTop: "1px solid #ededed",
            fontSize: 12.5,
            color: "#8c8c8c",
          }}
        >
          <LockOutlined style={{ color: acento }} />
          <span>
            Pagos procesados de forma segura mediante <strong>Conekta</strong>
          </span>
        </div>

        {/* Acción */}
        <div style={{ marginTop: 24 }}>
          <ButtonItem
            {...{ [contenido.botonColor]: true }}
            size="large"
            onClick={cerrarModal}
            style={{ display: "block", width: "100%" }}
          >
            Entendido
          </ButtonItem>
        </div>
      </Modal>
    );
  }
}

export default ModalAdvertenciaPago;
